angular.module('pl-shared')
  .component('questionLabelText', {
    bindings: {
      q: '<'
    },
    template: '<span class="pl-ellipsis">{{ renderContext.app.user ? $ctrl.q.questionText : $ctrl.q.questionLabel }}</span>',
    controller: function() {}
  })
